import React from 'react';
import PropTypes from 'prop-types';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { ModelsGridSection } from './models-grid-section/models-grid-section';

import './models-grid.scss';

export function ModelsGrid({ models, makeName }) {
  const electricModels = models.filter(({ engineTypes }) => engineTypes.includes('Electric'));
  const pluginHybridModels = models.filter(
    ({ engineTypes }) => !engineTypes.includes('Electric') && engineTypes.includes('Plug-in Hybrid')
  );
  const otherModels = models.filter(
    ({ engineTypes }) => !engineTypes.includes('Electric') && !engineTypes.includes('Plug-in Hybrid')
  );

  return (
    <div className="models-grid">
      {!!electricModels.length && (
        <ModelsGridSection
          heading={`${makeName} Electric Models`}
          iconClassName="icon-power2"
          models={electricModels}
        />
      )}
      {!!pluginHybridModels.length && (
        <ModelsGridSection
          heading={`${makeName} Plug-in Hybrid Models`}
          iconClassName="icon-power-cord-thin"
          models={pluginHybridModels}
        />
      )}
      {!!(otherModels.length || (!pluginHybridModels.length && !electricModels.length)) && (
        <ModelsGridSection heading={`${makeName} Models`} models={otherModels} />
      )}
    </div>
  );
}

ModelsGrid.propTypes = {
  makeName: PropTypes.string.isRequired,
  models: VehicleEntities.ModelYearsByMakeId.isRequired,
};
